// ExampleComponent.jsx
import { Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { RouterLink } from './routes/components';

export const Unauthorized = () => {
  return (<Stack sx={{ display: "flex", height: "100vh" }} justifyContent="center" alignItems="center">
    <Typography variant="h1" fontSize={"10em"} fontWeight={"bold"} color={"primary"}>403</Typography>
    <Typography variant="subtitle1" >Sorry, You don't have permission to access this page</Typography>
    <Button
      href="/"
      size="large"
      variant="contained"
      component={RouterLink}
      sx={{mt:2}}
    >
      Go to Home
    </Button>
  </Stack>)
};

